import * as React from 'react';

import OrderDeadline from '@/components/elements/Text/OrderDeadline';
import { Race } from '@/lib/apollo/types/gen/graphql';
import { twoWordsRaceEventNameMapper } from '@/lib/race';
import { getVelodromeByCode } from '@/lib/race/velodrome';
import { raceSelector } from '@/selectors/race';
import { toHalfWidth } from '@/utility/utils';

import { DeadLineText, RaceInfo, RaceInfoWrapper } from './style';

interface TicketHeaderProps {
  isReady: boolean;
  velodromeCode: number;
  race: Race;
}

const TicketHeader: React.FC<TicketHeaderProps> = React.memo(
  ({ isReady, velodromeCode, race }) => {
    return (
      <RaceInfoWrapper>
        <RaceInfo>
          <span>
            {`${getVelodromeByCode(velodromeCode).name} ${race.raceNum}R`}
          </span>
          <p>
            {toHalfWidth(
              `${race.raceClassName} ${twoWordsRaceEventNameMapper(
                race.raceEventName,
              )}`,
            )}
          </p>
        </RaceInfo>
        {isReady && (
          <DeadLineText>
            <OrderDeadline
              orderDeadline={raceSelector(race).marginedOrderDeadline}
            />
          </DeadLineText>
        )}
      </RaceInfoWrapper>
    );
  },
);

export default TicketHeader;
